import React from 'react';
import { Box, Card, CardContent, Chip, Grow, Typography } from '@mui/material';
import { BRAND, featureAccent } from '../theme/brand';

const FeatureCard = ({ feature, index, timeout = 300 }) => {
  const accent = featureAccent(index);

  return (
    <Grow in timeout={timeout + index * 50}>
      <Card
        sx={{
          height: '100%',
          transition: 'border-color 0.25s ease, transform 0.25s ease, box-shadow 0.25s ease',
          border: `1px solid ${BRAND.border}`,
          borderRadius: 2,
          backgroundColor: '#fff',
          boxShadow: 'none',
          '&:hover': {
            transform: 'translateY(-6px)',
            boxShadow: '0 16px 40px rgba(5, 47, 42, 0.08)',
            borderColor: accent,
          },
        }}
      >
        <CardContent sx={{ p: { xs: 2.5, md: 3 } }}>
          <Box
            sx={{
              mb: { xs: 1.5, md: 2 },
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              gap: 1,
            }}
          >
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: 1.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: `${accent}18`,
                border: `1px solid ${accent}33`,
                color: accent,
                flexShrink: 0,
              }}
            >
              {React.cloneElement(feature.icon, { sx: { fontSize: { xs: 26, md: 28 } } })}
            </Box>
            <Chip
              label={feature.category}
              size="small"
              sx={{
                backgroundColor: `${accent}14`,
                color: accent,
                fontWeight: 600,
                fontSize: { xs: '0.65rem', md: '0.7rem' },
                height: { xs: 22, md: 24 },
                border: `1px solid ${accent}28`,
              }}
            />
          </Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              mb: { xs: 1, md: 1.25 },
              color: BRAND.tealDark,
              fontSize: { xs: '1.05rem', md: '1.2rem' },
            }}
          >
            {feature.title}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: BRAND.textMuted,
              lineHeight: { xs: 1.65, md: 1.75 },
              fontSize: { xs: '0.875rem', md: '0.925rem' },
            }}
          >
            {feature.description}
          </Typography>
        </CardContent>
      </Card>
    </Grow>
  );
};

export default FeatureCard;
